import { Component, forwardRef, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RxHelper } from '../../core/utils/rxjxHelper';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
    selector: 'app-have-treatment-plan-radios',
    standalone: true,
    imports: [CommonModule, RadioButtonModule, FormsModule],
    templateUrl: './have-treatment-plan-radios.component.html',
    styleUrls: ['./have-treatment-plan-radios.component.scss'],
    providers: [
        RxHelper,
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => HaveTreatmentPlanRadiosComponent),
            multi: true,
        },
    ],
})
export class HaveTreatmentPlanRadiosComponent implements OnInit, ControlValueAccessor {
    @Input() showNone = true;
    @Input() isDisabled = false;

    protected value: boolean | null = null;

    private readonly _rxHelper = inject(RxHelper);

    protected onChangeFn?: (value: boolean | null) => unknown;
    protected onTouchedFn?: () => unknown;

    ngOnInit() {}

    protected onCheck(value: boolean | null) {
        this.value = value;
        this.onChangeFn?.(this.value);
    }

    writeValue(obj: unknown): void {
        if (typeof obj === 'boolean') {
            this.value = obj;
        } else {
            this.value = null;
        }
    }

    registerOnChange(fn: any): void {
        this.onChangeFn = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedFn = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }
}
